/* eslint-disable */

// Photo Gallery
import Swiper from 'swiper';
let clicked_before = false;
let MSwiper;

function CloseGallery() {
	$('.photoGalleryModal').modal('hide');

}


function loadmedia(url, index = 0) {
	$.getJSON(url, function (data) {
		var mylist = "",
			myTitle = "";

		if (typeof data === 'object') {
			$.each(data['media'], function (key, media) {
				if (media['video'] == 'true') {
					// mylist += '<div class="vedio-wrap  swiper-slide"> <iframe class="w-100 vimeovideo iframe-video"  width="100%" height="300"  iframe-video frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen  src="' + media['url'] + '" id="video"></iframe></div>';
					mylist += ` <div class="vedio-wrap  swiper-slide">
					                 <iframe class="w-100 vimeovideo rounded iframe-video"  width="100%" height="300"  iframe-video frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen  src="${ media['url'] }" id="video"></iframe>
							     	 <div class = "h3 my-1 font-weight-bold mb-2  mt-3 title"> ${ media['title'] } </div>
									 <div class = "text mb-3" >${ media['desc'] } </div>
								  </div>`;

				} else {
					// mylist += '<div class="photo-wrap  swiper-slide"><img class="img img-fluid mx-auto" src="' + media['url'] + '" alt="' + media['title'] + '"></div>';
					mylist += ` <div class="vedio-wrap  swiper-slide">
									<img class = "img rounded img-fluid mx-auto" src = "${ media['url'] }" >
									<div class = "h3 my-1 font-weight-bold mb-2  mt-3 title"> ${ media['title'] } </div>
									<div class = "text mb-3" >${ media['desc'] } </div>
							   </div>`;
				}

			});



			setTimeout(function () {

				// $(thisGalleryWrapp).html('');
				$('.photoGalleryModal').find('.slider-data').html('');


				let data_output = `<div class="gallery has-dynamic-bullets swiper-container">
				                         <div class=" swiper-wrapper align-items-center"></div>
									     <div class = "swiper-pagination position-relative my-2 dark   d-md-none  d-block"> </div>
									</div>`

				// $('.photoGalleryModal').find('.slider-data').html('<div class="gallery has-dynamic-bullets swiper-container"><div class=" swiper-wrapper align-items-center"></div><div class="swiper-pagination position-relative mt-4"></div></div>' + '<div class="title-photo-gallery">ddd dd</div>');
				$('.photoGalleryModal').find('.slider-data').html(data_output);

				$('.photoGalleryModal').find('.gallery .swiper-wrapper').html(mylist);

				$('.photoGalleryModal').removeClass('wait-load');


				//

				var thisSlider = $('.photoGalleryModal').find('.gallery');
				let dynamicBullets = false

				if (thisSlider.hasClass('has-dynamic-bullets')) {
					dynamicBullets = true
				}
				MSwiper = new Swiper(thisSlider, {

					spaceBetween: 0,
					loop: false,
					slidesPerView: 1,
					effect: 'fade',
					speed: 1000,
					preloadImages: false,

					lazy: {
						loadPrevNext: true,
					},

					// autoplay: {
					// 	delay: 2500,
					// },

					pagination: {
						el: $('.photoGalleryModal').find('.swiper-pagination'),
						clickable: true,
						dynamicBullets: dynamicBullets,
						dynamicMainBullets: 7,

					},


					navigation: {
						nextEl: $('.photoGalleryModal').find('.swiper-button-next'),
						prevEl: $('.photoGalleryModal').find('.swiper-button-prev'),
					},




					on: {
						slideChangeTransitionStart: function () {
							//alert('sa')
							//thisSlider.find('.fraction .current').html(MSwiper.activeIndex + 1)





						},
						slideChangeTransitionEnd: function () {
							let active = $('.photoGalleryModal').find('.swiper-slide-active').index();
							let id = $('.medi-items .item:not(".has-events-data")').eq(active).find('.has-events-data').data('id');
							window.pushUrlState('?' + modalItem + "=" + id)





						}
					}



				});


				MSwiper.slideTo(index, 0)




				var videos = $('[iframe-video]');
				//videos.forEach(function (video) {
				MSwiper.on('slideChangeTransitionStart', function () {

					var iframes = $('.vimeovideo');

					iframes.each(function () {
						var player = $f(this);
						player.api("pause");
					});
					return false;



				})








			}, 200);

		}
	});
};







if ($('.has-events-data').length) {



	$('.has-events-data').each(function () {
		let ActiveGallery = $(this);
		ActiveGallery.click(function () {



			let thisGalleryWrapp = $('#' + $(this).data('gallery'));
			let ActiveGallerySlider = thisGalleryWrapp.parents('body').find('.photoGalleryModal').find('.gallery');
			let DataUrl = $(this).closest('.all-media').data('url');
			let index = parseInt(0);
			if ($(this).attr('index')) {
				index = parseInt($(this).attr('index'));

			}

			$('.photoGalleryModal').modal('show');

			if (ActiveGallery.data('id') && !ActiveGallery.hasClass('stopPushState')) {
				let id = ActiveGallery.data('id');
				if (history.pushState) {
					window.pushUrlState('?' + modalItem + "=" + id)


				}
			}

			if (!clicked_before) {
				$('.photoGalleryModal').find('.slider-data').html('');
				loadmedia(DataUrl, index);
				$('.photoGalleryModal').addClass('wait-load');
				clicked_before = true;

			} else {
				MSwiper.slideTo(index, 0)

			}









		});

	});
}


//for opening Modal
let url = '';
let furl = window.location.href;

function GetURLParameter(sParam) {

	var sPageURL = window.location.search.substring(1);

	var sURLVariables = sPageURL.split('&');

	for (var i = 0; i < sURLVariables.length; i++) {

		var sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] == sParam) {

			return sParameterName[1];

		}

	}

}

$('.photoGalleryModal ,.modal.members').on('hide.bs.modal', function () {
	$('.activeShowinDetails').removeClass('activeShowinDetails');
	if ((history.pushState)) {

		url = "?";

		window.pushUrlState('?')


	}
})
if (typeof modalItem !== 'undefined' && (furl.indexOf('?' + modalItem + '=') != -1)) {

	let active_Item = (GetURLParameter(modalItem));
	if ((active_Item) && ($('*[data-id=' + active_Item + ']').length)) {
		$('*[data-id=' + active_Item + ']').click();

		var n = $('*[data-id=' + active_Item + ']');
		//	n.addClass('active')
		$("html,body").animate({
			scrollTop: n.offset().top + 50
		}, 500);

	}


}


//end modal
